import React from 'react';
import { useIntl } from 'react-intl';

import { Grid } from '@xsolla/ui-core';

import { usePaths } from '../../../routes/routesHelper';
import { CallbackUrlIcon, EmailValidateIcon, ToggleBox } from '../../ui';
import NavigationSettingsLink from '../NavigationSettingsLink';
import { ContentWrapper } from './style';

interface Props {
  projectId: string;
}

const ShadowLoginSettings = ({ projectId }: Props): JSX.Element => {
  const { callbackUrlsSettingsPath, platformSettingsPath } = usePaths();
  const intl = useIntl();

  return (
    <ToggleBox title={intl.messages['navigation.settings.authentication.label']} openByDefault>
      <ContentWrapper>
        <Grid cols={2} gap={24}>
          <NavigationSettingsLink
            dataTestId="link-navigation-callback-urls"
            icon={<CallbackUrlIcon />}
            titleInfo={{
              label: intl.messages['navigation.settings.callback.title'],
              path: callbackUrlsSettingsPath(projectId)
            }}
            subtitle={intl.messages['navigation.settings.callback.subtitle']}
          />
          <NavigationSettingsLink
            dataTestId="link-navigation-social-cross"
            icon={<EmailValidateIcon />}
            titleInfo={{
              label: intl.messages['navigation.settings.authentication.publisher-platforms.title'],
              path: platformSettingsPath(projectId)
            }}
            subtitle={intl.messages['social-connection.subtitle']}
          />
        </Grid>
      </ContentWrapper>
    </ToggleBox>
  );
};

export default ShadowLoginSettings;
